import { GridComparatorFn } from '@mui/x-data-grid-pro';
import { ItemType } from 'src/types';

export const sortArrayLengthFn: GridComparatorFn<Array<any>> = (v1, v2) =>
  v1.length - v2.length;

export const sortItemTypeFn: GridComparatorFn<ItemType | null | undefined> = (v1, v2) =>
  (v1?.name ?? '').localeCompare(v2?.name ?? '');

export const sortStringPropFn: (prop: string) => GridComparatorFn<any | null | undefined> =
  (prop: string) => (v1, v2) => (v1?.[prop] ?? '').localeCompare(v2?.[prop] ?? '');